import React from 'react'

import { IconProps } from '../Types'

export const Activity = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="Activity"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path fill-rule="evenodd" d="m4.38,4c-.1,0-.2.04-.27.11-.07.07-.11.17-.11.27v3.46c0,.55-.45,1-1,1s-1-.45-1-1v-3.46c0-.63.25-1.24.7-1.69.45-.45,1.05-.7,1.69-.7h3.46c.55,0,1,.45,1,1s-.45,1-1,1h-3.46Zm10.77-1c0-.55.45-1,1-1h3.46c.63,0,1.24.25,1.69.7.45.45.7,1.05.7,1.69v3.46c0,.55-.45,1-1,1s-1-.45-1-1v-3.46c0-.1-.04-.2-.11-.27-.07-.07-.17-.11-.27-.11h-3.46c-.55,0-1-.45-1-1Zm-5.92,3.15c.42,0,.79.26.93.66l1.97,5.43,1.73-3.46c.16-.33.49-.54.86-.55.36-.01.71.17.9.48l1.79,2.98h2.9c.55,0,1,.45,1,1s-.45,1-1,1h-3.46c-.35,0-.68-.18-.86-.49l-1.14-1.9-1.95,3.91c-.18.36-.55.57-.95.55-.4-.02-.75-.28-.88-.66l-1.84-5.07-1.13,3c-.15.39-.52.65-.94.65h-3.46c-.55,0-1-.45-1-1s.45-1,1-1h2.77l1.83-4.89c.15-.39.52-.65.94-.65ZM3,15.15c.55,0,1,.45,1,1v3.46c0,.1.04.2.11.27.07.07.17.11.27.11h3.46c.55,0,1,.45,1,1s-.45,1-1,1h-3.46c-.63,0-1.24-.25-1.69-.7-.45-.45-.7-1.05-.7-1.69v-3.46c0-.55.45-1,1-1Zm18,0c.55,0,1,.45,1,1v3.46c0,.63-.25,1.24-.7,1.69-.45.45-1.05.7-1.69.7h-3.46c-.55,0-1-.45-1-1s.45-1,1-1h3.46c.1,0,.2-.04.27-.11.07-.07.11-.17.11-.27v-3.46c0-.55.45-1,1-1Z"/>',
    }}
  />
)

Activity.displayName = 'Activity'

export const tags = ['Activity', '']
